import React from 'react';
import { MdStar, MdStarOutline } from 'react-icons/md';

const StarRate = ({
  rating,
  setRating,
  disabled,
  size = 27,
}: {
  rating: number;
  setRating: (value: number) => void;
  disabled?: boolean;
  size?: number;
}) => {
  const handleRatingClick = (newRating: number) => {
    setRating(newRating);
  };

  return (
    <div className="flex">
      {[...Array(5)].map((_, index) => {
        const currentStar = index + 1;
        return (
          <div key={currentStar}>
            <label className="cursor-pointer">
              <input
                type="radio"
                name="rating"
                value={currentStar}
                onClick={() => handleRatingClick(currentStar)}
                className="hidden"
                disabled={disabled}
              />
              {currentStar <= (rating || 0) ? (
                <MdStar size={size} className="text-reliableBlack90" style={{ color: '#FFD12B' }} />
              ) : (
                <MdStarOutline size={size} className="text-reliableBlack90" />
              )}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default StarRate;
